import { render, staticRenderFns } from "./CardPersonalizationReport.vue?vue&type=template&id=6bd8fa34"
import script from "./CardPersonalizationReport.vue?vue&type=script&lang=js"
export * from "./CardPersonalizationReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports